<template>
  <div class="container" ref="container">
    <van-list
      v-model="listloading"
      :finished="listfinished"
      :immediate-check="false"
      finished-text="没有更多啦"
      @load="listload_more()"
    >
      <div v-for="(item, index) in list" :key="index" class="main">
        <div class="maintop" style="margin-bottom: 10px">
          <img
            v-if="item.headimg"
            :src="item.headimg"
            @click="tohomepage(item.m_id)"
            alt=""
          />
          <img
            v-else
            src="//pic-cdn.bigdatajy.com/wenming/static/img/icon3.png"
            @click="tohomepage(item.m_id)"
            alt=""
          />
          <div>
            <p>
              {{ item.member_name
              }}<span class="level">({{ item.level_str }})</span>
            </p>
            <p class="level" style="color: red">{{ item.org_name }}</p>
          </div>
          <div
            class="bt"
            v-if="my_id != item.m_id"
            @click="follow(item.m_id, index, list)"
            :class="{ ygz: item.isfollow }"
          >
            <p v-show="!item.isfollow">+关注</p>
            <p v-show="item.isfollow">已关注</p>
          </div>
        </div>
        <div>
          <p class="content">{{ item.content }}</p>
          <div class="pics" v-show="item.imgs.length > 0">
            <img
              :src="value"
              v-for="(value, index) in item.imgs"
              :key="index"
              alt=""
              @click="preview(item.imgs, index)"
            />
          </div>
          <div class="video" v-show="item.video">
            <video
              :src="item.video"
              controls
              preload
              style="
                width: 100%;
                height: 56vw;
                object-fit: cover;
                background: black;
              "
            ></video>
          </div>
          <p class="date">{{ timeTrans(item.createtime) }}</p>
          <p class="tag">
            来自活动<span>#{{ item.task_title }}#</span>
          </p>
          <!-- 评论区，最多显示5个，多的折叠，一次放十个 -->
          <div class="commentzoom" v-if="item.state == 2">
            <div
              v-for="(item2, index2) in item.comments"
              :key="item2.id"
              style="margin: 10px auto"
            >
              <div
                class="flexcomment"
                v-show="index2 < item.showcomment + (item.commentnum - 1) * 10"
              >
                <img
                  v-if="item2.headimg"
                  :src="item2.headimg"
                  class="txsmall"
                  alt=""
                  @click="tohomepage(item2.m_id)"
                />
                <img
                  v-else
                  src="//pic-cdn.bigdatajy.com/wenming/static/img/icon3.png"
                  class="txsmall"
                  alt=""
                  @click="tohomepage(item2.m_id)"
                />
                <div>
                  <p style="font-size: 12px; color: grey">
                    {{ item2.m_name }}&emsp;{{ timeTrans(item2.createtime) }}
                  </p>
                  <p style="font-size: 14px">{{ item2.content }}</p>
                </div>
              </div>
            </div>
            <!-- new part comment -->
            <van-divider
              :style="{ color: '#1989fa', padding: '0 16px' }"
              v-if="
                item.comments.length >
                item.showcomment + (item.commentnum - 1) * 10
              "
              @click="showmorecomment(list, index)"
            >
              查看剩余评论
            </van-divider>
          </div>
          <!-- 完毕 -->
          <div class="flex" style="margin: 10px 0">
            <img
              :src="tx"
              v-if="tx"
              class="txsmall"
              alt=""
              @click="tohomepage(my_id)"
            />
            <img
              src="//pic-cdn.bigdatajy.com/wenming/static/img/icon3.png"
              class="txsmall"
              alt=""
              v-else
            />
            <el-input
              type="textarea"
              readonly
              placeholder="随时回应"
              v-model="item.pinglun"
              autosize
              @click.native="choosepinglun(list, index)"
            ></el-input>
            <van-icon
              style="margin-left: 10px; margin-top: 5px"
              name="comment-o"
              size="24"
              @click="item.pinglun && send(item.id, item.pinglun, list, index)"
            />
          </div>
          <hr />
          <div class="flexicon">
            <div
              @click="
                share(item.task_id, item.task_title, index, list, item.id)
              "
            >
              <van-icon name="share-o" size="14" />
              <span>{{ item.zhuanfa }}</span>
            </div>
            <div
              @click="shoucang(item.id, index, list)"
              :class="{ red: item.isfav }"
            >
              <van-icon name="like-o" size="14" v-show="!item.isfav" />
              <van-icon name="like" size="14" color="red" v-show="item.isfav" />
              <span>{{ item.fav }}</span>
            </div>
            <div
              @click="dianzan(item.id, index, list)"
              :class="{ red: item.iszan }"
            >
              <van-icon name="good-job-o" size="14" v-show="!item.iszan" />
              <van-icon
                name="good-job"
                size="14"
                color="red"
                v-show="item.iszan"
              />
              <span>{{ item.zan }}</span>
            </div>
          </div>
        </div>
      </div>
    </van-list>
    <!-- new -->
    <van-popup
      v-model="show"
      round
      position="bottom"
      :style="{ height: '60%' }"
    >
      <div class="comments">
        <p @click="choose()">志愿者最光荣，你们是江阴美丽的风景线。</p>
        <p @click="choose()">这次活动我有事没参加，下次活动请带带我。</p>
        <p @click="choose()">你们真是太棒了，粉了粉了！</p>
        <p @click="choose()">这个活动真不错，我来学习学习！</p>
        <p @click="choose()">已转发已点赞，好的品行要传扬！</p>
        <p @click="choose()">初到贵宝地，看到你们的活动，赞一个！</p>
        <p @click="choose()">咱们队友真是棒棒哒，下次继续一起活动哈！</p>
        <p @click="choose()">这个活动真不错，要继续推广下去！</p>
      </div>
    </van-popup>
    <!-- end -->
    <!-- 如果不是APP中打开，提示在APP中打开 -->
    <div class="openmore" v-if="!isapp">
      <van-icon name="arrow-down" size="14" />
      <van-icon name="arrow-down" size="20" />
      <div class="btopen" @click="testApp">打开最江阴APP查看所有内容</div>
    </div>
  </div>
</template>
<script>
import { ImagePreview } from "vant";
export default {
  name: "topic",
  data() {
    return {
      list: [],
      tx: "",
      my_id: "",
      listloading: false,
      listfinished: false,
      listpage: 1,
      showPopover: false,
      show: false,
      chooselist: "",
      chooselistindex: "",
      myname: "",
      isapp: true,
      url: "//zhuzhan.ijiangyin.com/siteapp/appClient/sign",
      appId: "2312",
    };
  },
  created() {
    zjyapi.init({
      appId: this.appId,
      error: function (code, ret) {
        //失败回调,默认
        Toast("初始化失败");
      },
      success: function success(ret) {},
    });
    //我的信息
    this.$axios({
      method: "post",
      url: "/api/home/index",
    }).then((res) => {
      console.log(res.data);
      this.my_id = res.data.data.member.id;
      this.tx = res.data.data.member.img;
      if (res.data.data.member.img == "") {
        this.tx = "//pic-cdn.bigdatajy.com/wenming/static/img/icon3.png";
      }
      this.myname = res.data.data.member.name;
    });
    this.$axios({
      method: "post",
      url: "/api/report/showlist",
      data: this.qs.stringify({
        task_id: this.$route.query.id,
      }),
    }).then((res) => {
      this.list = res.data.data.list;
      console.log(this.list);
      for (let i in this.list) {
        if (this.list[i].imgs != "") {
          this.list[i].imgs = this.list[i].imgs.split(",");
        }
        this.list[i].showcomment = 5;
        this.list[i].commentnum = 1;
        this.list[i].commentnummax = Math.ceil(
          (this.list[i].comments.length - this.list[i].showcomment) / 10
        );
      }
    });
    //判断是否在APP中打开
    //判断当前平台方法
  },
  mounted() {
    var browser = {
      versions: (function () {
        var u = navigator.userAgent;
        return {
          trident: u.indexOf("Trident") > -1,
          presto: u.indexOf("Presto") > -1,
          webKit: u.indexOf("AppleWebKit") > -1,
          gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1,
          mobile: !!u.match(/AppleWebKit.*Mobile.*/),
          ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
          android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1,
          iPhone: u.indexOf("iPhone") > -1,
          iPad: u.indexOf("iPad") > -1,
          webApp: u.indexOf("Safari") == -1,
          uc:
            (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) &&
            u.indexOf("UCBrowser") > -1,
          weixin: u.toLowerCase().match(/MicroMessenger/i) == "micromessenger", //判断微信
          iosApp: u.match(/ByIphone/i) != null, //判断ios版app
          androidApp: u.match(/ByAndroid/i) != null, //判断android版app
          iPhoneOs:
            u.indexOf("iPhone") > -1 && u.indexOf("Mobile") > -1
              ? /CPU (?:iPhone )?OS (\d+_\d+)/.test(u)
                ? parseFloat(RegExp.$1.replace("_", "."))
                : 2
              : null, //返回ios版本号
        };
      })(),
    };
    if (!browser.versions.iosApp && !browser.versions.androidApp) {
      //如果不在app中打开
      console.log("未在APP中打开");
      this.isapp = false;
      this.$refs.container.style.width = "100vw";
      this.$refs.container.style.height = "100vh";
      this.$refs.container.style.overflow = "hidden";
      console.log(
        encodeURIComponent("https://www.jywmsj.cn/h5/#/topic?id=47")
      );
    }
  },
  methods: {
    //add 跳转打开APP或者跳转到APP下载页面
    testApp() {
      let userAgent = navigator.userAgent;
      let iosOpenUrl =
        "jyrmt://?linktype=2&linkurl=" + encodeURIComponent(location.href); //打开地址
      let iosDownUrl =
        "http://newht.ijiangyin.com:5577/index.php?g=Portal&m=News&a=app"; //下载地址
      let androidOpenUrl =
        "jyrmt://?linktype=2&linkurl=" + encodeURIComponent(location.href);
      let androidDownUrl =
        "http://newht.ijiangyin.com:5577/index.php?g=Portal&m=News&a=app";
      let delayTime = 500;
      if (userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        var firstTime = new Date();
        window.location = iosOpenUrl;
        window.setTimeout(function () {
          var secondTime = new Date();
          if (secondTime - firstTime < 5000) {
            window.location = iosDownUrl;
          } else {
            window.close();
          }
        }, delayTime);
      } else if (userAgent.match(/android/i)) {
        try {
          window.location = androidOpenUrl;
          window.setTimeout(function () {
            window.location = androidDownUrl;
          }, delayTime);
        } catch (eror) {
          console.log(eror);
        }
      }
    },
    //to add 分享
    share(id, title, index, list, reportid) {
      this.openShare(title, id, index, list, reportid);
    },
    //app相关开始
    //获取签名方法
    getSign: function (fun) {
      /*请求参数*/
      var paramObj = {
        httpUrl: this.url,
        type: "post",
        data: {
          appId: this.appId,
        },
      };
      /*请求调用*/
      this.httpRequest(paramObj, fun, function () {
        alert("获取签名失败错误");
      });
    },
    httpRequest: function (paramObj, fun, errFun) {
      var xmlhttp = null;
      /*创建XMLHttpRequest对象，
       *老版本的 Internet Explorer（IE5 和 IE6）使用 ActiveX 对象：new ActiveXObject("Microsoft.XMLHTTP")
       * */
      if (window.XMLHttpRequest) {
        xmlhttp = new XMLHttpRequest();
      } else if (window.ActiveXObject) {
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
      }
      /*判断是否支持请求*/
      if (xmlhttp == null) {
        alert("你的浏览器不支持XMLHttp");
        return;
      }
      /*请求方式，并且转换为大写*/
      var httpType = (paramObj.type || "GET").toUpperCase();
      /*数据类型*/
      var dataType = paramObj.dataType || "json";
      /*请求接口*/
      var httpUrl = paramObj.httpUrl || "";
      /*是否异步请求*/
      var async = paramObj.async || true;
      /*请求参数--post请求参数格式为：foo=bar&lorem=ipsum*/
      var paramData = paramObj.data || [];
      var requestData = "";
      for (var name in paramData) {
        requestData += name + "=" + paramData[name] + "&";
      }
      requestData =
        requestData == ""
          ? ""
          : requestData.substring(0, requestData.length - 1);
      console.log(requestData);
      /*请求接收*/
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
          /*成功回调函数*/
          //获取签名数据成功:{"serverTime":null,"error":"200","msg":"成功","data":{"appSign":"b37808616bda9d71e100e0971881101d","appId":"2312""timestamp":1575953679723},"map":null}
          console.log("获取签名数据成功:" + xmlhttp.responseText);
          var obj = JSON.parse(xmlhttp.responseText);
          var data = obj.data;
          fun({
            timestamp: data.timestamp,
            sign: data.appSign,
          });
        } else {
          /*失败回调函数*/
          errFun;
        }
      };
      /*接口连接，先判断连接类型是post还是get*/
      if (httpType == "GET") {
        xmlhttp.open("GET", httpUrl, async);
        xmlhttp.send(null);
      } else if (httpType == "POST") {
        xmlhttp.open("POST", httpUrl, async);
        //发送合适的请求头信息
        xmlhttp.setRequestHeader(
          "Content-type",
          "application/x-www-form-urlencoded"
        );
        xmlhttp.send(requestData);
      }
    },
    openShare: function (title, id, index, list, reportid) {
      var that = this;
      this.getSign(function (sign) {
        zjyapi.openShare({
          sign: sign,
          params: {
            title: "江阴市新时代文明实践中心",
            content:
              "我在看大家参与" + title + "活动的图文及心得，你也快来看一看",
            url: "https://www.jywmsj.cn/h5/#/topic?id=" + id, //分享地址
            imgUrl:
              "https://pic-cdn.bigdatajy.com/wenming/static/img/default.png", //分享图标地址
          },
          success: function (ret) {
            console.log("分享成功：" + ret);
            var data = JSON.parse(ret);
            console.log(ret);
            console.log(data);
            that.zhuanfa(reportid, index, list);
          },
          error: function (error) {
            that.$toast("分享失败");
            console.log("分享失败：" + JSON.stringify(error));
          },
        });
      });
    },
    //end
    //to add 点击更多加载更多10条评论
    showmorecomment(list, index) {
      list[index].commentnum += 1;
      this.$forceUpdate();
    },
    preview(imgs, index) {
      //console.log(imgs);
      ImagePreview({
        images: imgs,
        startPosition: index,
      });
    },
    choosepinglun(list, index) {
      this.chooselist = list;
      this.chooselistindex = index;
      this.show = true;
    },
    choose() {
      console.log(event.target.innerText);
      this.chooselist[this.chooselistindex].pinglun = event.target.innerText;
      this.show = false;
    },
    send(id, pinglun, list, index) {
      this.$axios({
        method: "post",
        url: "/api/report/comment",
        data: this.qs.stringify({
          report_id: id,
          content: pinglun,
        }),
      }).then((res) => {
        console.log(res.data);
        if (res.data.code == 0) {
          this.$toast("操作成功");
          console.log(list[index].pinglun);
          list[index].comments.unshift({
            content: list[index].pinglun,
            createtime: Date.parse(new Date()) / 1000,
            id: new Date().valueOf(),
            m_id: this.my_id,
            m_name: this.myname,
            headimg: this.tx,
          });
          list[index].showcomment += 1;
          list[index].pinglun = "";
          this.$forceUpdate();
        } else {
          this.$toast(res.data.msg);
        }
      });
    },
    tohomepage(id) {
      this.$router.push({
        name: "homepage",
        query: {
          id: id,
        },
      });
    },
    //to add 转发
    zhuanfa(id, index, list) {
      this.$axios({
        method: "post",
        url: "/api/report/zhuanfa",
        data: this.qs.stringify({
          report_id: id,
        }),
      }).then((res) => {
        console.log(res.data);
        list[index].zhuanfa += 1;
        /* if(res.data.code == 0){
          list[index].zhuanfa += 1;
          this.$toast('转发成功');
        }else{
          this.$toast(res.data.msg);
        } */
      });
    },
    //to add 点赞
    dianzan(id, index, list) {
      if (list[index].iszan == 1) {
        //取消
        this.$axios({
          method: "post",
          url: "/api/report/zan",
          data: this.qs.stringify({
            report_id: id,
            type: 2,
          }),
        }).then((res) => {
          console.log(res.data);
          if (res.data.code == 0) {
            list[index].iszan = null;
            list[index].zan -= 1;
          } else {
            this.$toast(res.data.msg);
          }
        });
      } else {
        //点赞
        this.$axios({
          method: "post",
          url: "/api/report/zan",
          data: this.qs.stringify({
            report_id: id,
            type: 1,
          }),
        }).then((res) => {
          console.log(res.data);
          if (res.data.code == 0) {
            list[index].iszan = 1;
            list[index].zan += 1;
          } else {
            this.$toast(res.data.msg);
          }
        });
      }
    },
    //to add 收藏
    shoucang(id, index, list) {
      if (list[index].isfav == 1) {
        //取消收藏
        this.$axios({
          method: "post",
          url: "/api/report/fav",
          data: this.qs.stringify({
            report_id: id,
            type: 2,
          }),
        }).then((res) => {
          console.log(res.data);
          if (res.data.code == 0) {
            list[index].isfav = null;
            list[index].fav -= 1;
          } else {
            this.$toast(res.data.msg);
          }
        });
      } else {
        //收藏
        this.$axios({
          method: "post",
          url: "/api/report/fav",
          data: this.qs.stringify({
            report_id: id,
            type: 1,
          }),
        }).then((res) => {
          console.log(res.data);
          if (res.data.code == 0) {
            list[index].isfav = 1;
            list[index].fav += 1;
          } else {
            this.$toast(res.data.msg);
          }
        });
      }
    },
    follow(id, index, list) {
      if (list[index].isfollow == 1) {
        //取消关注
        this.$axios({
          method: "post",
          url: "/api/report/follow",
          data: this.qs.stringify({
            member_id: id,
            type: 2,
          }),
        }).then((res) => {
          console.log(res.data);
          if (res.data.code == 0) {
            list[index].isfollow = null;
            this.followrefresh(list, null, list[index].m_id);
          } else {
            this.$toast(res.data.msg);
          }
        });
      } else {
        //关注
        this.$axios({
          method: "post",
          url: "/api/report/follow",
          data: this.qs.stringify({
            member_id: id,
            type: 1,
          }),
        }).then((res) => {
          console.log(res.data);
          if (res.data.code == 0) {
            list[index].isfollow = 1;
            this.followrefresh(list, 1, list[index].m_id);
          } else {
            this.$toast(res.data.msg);
          }
        });
      }
    },
    //关注之后轮询现有条目
    followrefresh(list, num, id) {
      for (let i in list) {
        if (list[i].m_id == id) {
          list[i].isfollow = num;
        }
      }
      this.$forceUpdate();
    },
    listload_more() {
      this.listpage += 1;
      var that = this;
      setTimeout(function () {
        that
          .$axios({
            method: "post",
            url: "/api/report/showlist",
            data: that.qs.stringify({
              page: that.listpage,
              task_id: that.$route.query.id,
            }),
          })
          .then((res) => {
            console.log(res.data);
            if (res.data.code == 0) {
              for (let i in res.data.data.list) {
                if (res.data.data.list[i].imgs != "") {
                  res.data.data.list[i].imgs =
                    res.data.data.list[i].imgs.split(",");
                }
                res.data.data.list[i].showcomment = 5;
                res.data.data.list[i].commentnummax = Math.ceil(
                  (res.data.data.list[i].comments.length -
                    res.data.data.list[i].showcomment) /
                    10
                );
              }
              that.list = that.list.concat(res.data.data.list);
            }
            that.listloading = false;
            if (res.data.data.list.length == 0) {
              //数据全部加载完成
              that.listfinished = true;
            } else {
              that.listfinished = false;
            }
          });
      }, 500);
    },
  },
};
</script>
<style scoped>
.container {
  min-height: 100vh;
  background: #f2f2f2;
}
.main {
  padding: 7vw;
  padding-bottom: 0;
  background: white;
  margin-bottom: 10px;
}
.maintop {
  display: flex;
}
.maintop img {
  width: 15vw;
  height: 15vw;
  object-fit: cover;
  border-radius: 50%;
  display: block;
  margin-right: 10px;
  flex-shrink: 0;
}
.maintop .bt {
  margin-left: auto;
  align-self: center;
  border: 1px solid #bbbbbb;
  border-radius: 5px;
  padding: 5px 10px;
  white-space: nowrap;
}
.pics {
  display: flex;
  flex-wrap: wrap;
}
.pics img {
  width: 25vw;
  height: 25vw;
  object-fit: cover;
  margin: 2%;
}
.date {
  color: #a1a1a1;
  font-size: 12px;
}
.tag {
  font-size: 12px;
}
.tag span {
  color: red;
}
.level {
  font-size: 12px;
}
.content {
  font-size: 14px;
}
.txsmall {
  width: 10vw;
  height: 10vw;
  object-fit: cover;
  border-radius: 50%;
  margin-right: 10px;
}
.flex {
  display: flex;
}
.el-textarea {
  width: 100%;
  outline: none;
  border: none;
  background: #f4f5f9;
  border-radius: 30px;
  line-height: 30px;
  font-size: 14px;
  min-height: 30px;
  text-indent: 10px;
}
.el-textarea /deep/ .el-textarea__inner {
  border-radius: 15px;
}
hr {
  margin: 10px 10px 0 10px;
}
.flexicon {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.flexicon > div {
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #cdcacb;
  font-size: 14px;
}
.flexicon .van-icon {
  color: #cdcacb;
}
.red {
  color: red !important;
}
.ygz {
  color: white;
  background: #cab586;
}
.comments {
  padding: 10px;
  background: white;
  border-radius: 10px;
}
.comments {
  padding: 15px;
}
.comments p {
  margin: 10px auto;
  border: 1px solid #eee;
  border-radius: 10px;
  padding: 10px;
}
.commentzoom {
  margin: 15px auto;
}
.flexcomment {
  display: flex;
}
.openmore {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  color: #cab586;
  text-align: center;
}
.openmore .van-icon {
  display: block;
  margin: 0 auto;
}
.btopen {
  width: 80%;
  margin: 30px auto;
  border-radius: 20px;
  padding: 10px;
  background: #cab586;
  color: white;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/topic.vue